import React from 'react'
import { useHistory } from 'react-router-dom'
import PageWrapper from '../../../wrappers/pageWrapper/PageWrapper'
import AddEnodeDevice from '../addEnodeDevice/AddEnodeDevice'

const ElectricVehicleOnboarding: React.FC = () => {
	const history = useHistory()

	const goForward = () => history.push('/devices/add-device/electric-car/setup')

	return (
		<PageWrapper page='addElectricCar' appBarOptions={{ backPath: '/devices/add-device' }}>
			<AddEnodeDevice goForward={goForward} type='vehicle' />
		</PageWrapper>
	)
}

export default ElectricVehicleOnboarding
